<template>
  <div class="login-page">
    <div class="left-section">
      <div class="animation-container">
        <h2 class="welcome-text">Miss Coquette</h2>
        <p class="welcome-subtext">La mejor experiencia en renta de vestidos</p>
      </div>
    </div>

    <div class="login-form-container">
      <div class="login-card">
        <h2 class="login-title">Iniciar Sesión</h2>
        <form @submit.prevent="submitForm">
          <div class="input-group">
            <label for="username" class="input-label">Usuario</label>
            <input id="username" v-model="username" type="text" class="input-field" required placeholder="Introduce tu usuario" />
          </div>

          <div class="input-group">
            <label for="password" class="input-label">Contraseña</label>
            <input id="password" v-model="password" type="password" class="input-field" required placeholder="Introduce tu contraseña" />
          </div>

          <button type="submit" ref="btnLogin" class="btn-login">Iniciar Sesión</button>
        </form>

        <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import baseUrl from "../api";
import { useRouter } from "vue-router";
import { mapActions } from "vuex";
import gsap from 'gsap';

export default {
  setup() {
    const router = useRouter();
    return { router };
  },
  data() {
    return {
      username: "",
      password: "",
      errorMessage: "",
    };
  },
  mounted() {
    gsap.from(this.$refs.btnLogin, {
      y: 50,
      opacity: 0,
      duration: 1,
      ease: "back.out(1.7)",
      delay: 0.3
    });
  },
  methods: {
    ...mapActions(["login"]),
    async submitForm() {
      if (this.username && this.password) {
        try {
          const url = `${baseUrl}/api/loginmisscoquette`;
          const response = await axios.post(url, {
            email: this.username,
            password: this.password,
          });
          if (response.data.success) {
            this.errorMessage = "";
            const userId = response.data.user.id_usuario;
            this.login(userId);
            localStorage.setItem("id_usuario", userId);
            this.router.push({ name: "stock" });
          } else {
            this.errorMessage = response.data.message;
          }
        } catch (error) {
          this.errorMessage = "Contraseña y/o usuario incorrecto";
          console.error(error);
        }
      } else {
        this.errorMessage = "Por favor, completa todos los campos.";
      }
    }
  }
};
</script>

<style scoped>
.login-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(180deg, #fef6fa, #ffffff);
  padding: 30px 20px;
  box-sizing: border-box;
}

.left-section {
  text-align: center;
  margin-bottom: 20px;
}

.welcome-text {
  font-size: 1.6rem;
  font-weight: bold;
  color: #c36aa0;
  font-family: 'jour';
  margin-bottom: 6px;
}

.welcome-subtext {
  font-size: 0.9rem;
  color: #6c6b6b;
  font-family: 'Karla', sans-serif;
}

.login-form-container {
  width: 100%;
  max-width: 360px;
}

.login-card {
  width: 100%;
  background: #ffffff;
  padding: 22px;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(170, 104, 139, 0.1);
  text-align: center;
  border: 1px solid #f3e1eb;
}

.login-title {
  font-size: 1.4rem;
  margin-bottom: 20px;
  color: #3d3d3d;
  font-weight: bold;
  font-family: 'Karla', sans-serif;
}

.input-group {
  margin-bottom: 10px; /* Reducido para acercar los campos */
  text-align: left;
}


.input-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #6a6a6a;
  margin-bottom: 4px;
  display: block;
  font-family: 'Karla';
}

.input-field {
  width: 100%;
  padding: 10px 12px;
  font-size: 0.95rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #fcfcfc;
  font-family: 'Karla', sans-serif;
  transition: border-color 0.3s ease;
}

.input-field:focus {
  border-color: #cc87a2;
  outline: none;
}

.btn-login {
  width: 100%;
  padding: 11px;
  margin-top: 0px;
  font-size: 1rem;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  font-weight: 600;
  font-family: 'Karla';
  background: linear-gradient(135deg, #c36aa0, #fca2cf);
  color: white;
  box-shadow: 0 4px 15px rgba(0,0,0,0.15);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.btn-login:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(195, 106, 160, 0.4);
}

.error-message {
  color: #e53935;
  font-size: 0.88rem;
  margin-top: 12px;
  font-family: 'Karla';
}

@media (max-width: 600px) {
  .login-page {
    justify-content: flex-start;
    padding-top: 90px;
  }

  .login-form-container {
    max-width: 90%;
    margin-top: 10px;
  }

  .welcome-text {
    font-size: 1.4rem;
  }

  .welcome-subtext {
    font-size: 0.85rem;
  }

  .login-card {
    padding: 18px;
  }

  .btn-login {
    font-size: 0.9rem;
  }
}
</style>
